import React from "react"
import "./LayoutTemplate.css"

/**
 * Anonymous component to render a wrapper.
 */
export default ({ children }) => {
  return <div className="wrapper">{children}</div>
}
